module.exports = __webpack_public_path__ + "img/img4.372a9dd6.jpg";